import { render } from "./ModalComponent.vue?vue&type=template&id=5b99b1b7&scoped=true"
import script from "./ModalComponent.vue?vue&type=script&lang=js"
export * from "./ModalComponent.vue?vue&type=script&lang=js"

import "./ModalComponent.vue?vue&type=style&index=0&id=5b99b1b7&lang=css"
import "./ModalComponent.vue?vue&type=style&index=1&id=5b99b1b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b99b1b7"]])

export default __exports__